import React from 'react'

import UI5ControlButton from "../../../../layout/app-controls/buttons/button/button"
import ProjectSession from "../../../model2/project/project-session"

type Props = {
    className?  : string

    project     : ProjectSession
}

export default function ControlShowInProjectsTree(props:Props) {

    const onClick = async () => {

        // patch - sometimes we pass data from views like TABLE whre projects are not really session projects
        // and they do not have parentTree !!!
        const realSessionProject = gd.session.projects.get(props.project.id)
        realSessionProject?.showInMainMenu()

        // props.project.showInMainMenu()
    }

    if (props.project.isReport)                                                 return null
    if (props.project.isTemplate)                                               return null
    if (props.project.systemType === gd.const.project.type.TAG)                 return null
    if (!gd.ac.check.project.standardAccess(props.project.id, props.project))   return null

    return (
        <UI5ControlButton className = {Classes('show-in-menu-button', props.className)}
                          iconClass = "ii5-aim ui5-color-system-gray project-aim"
                          fontSize  = "15"
                          hint      = "Show in main menu"
                          onClick   = {onClick}/>
    )
}
